import { useState, memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthenticationForms from "./AuthenticationForms";
import { getFromLocal } from "src/utils";
import FieldInput from "src/component/FieldInput/FieldInput";
import SubmitBtn from "src/component/ActionBtn/SubmitBtn";
import { useForm } from "src/hooks/useForm";
import { ResetUserPassword } from "src/requests/user";

type resetDataType = {
  password: string
  phoneNumber: string
  code: string
}


const default_cred = { otpCode: "", password: "" };

const ResetPasswordC = () => {

  const { register, handleSubmit } = useForm();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const resetPassword = (data: any) => {
    var ResetPasswordData: resetDataType = {
      password: data.password.value,
      phoneNumber: getFromLocal("phoneNumberforChange"),
      code: data.otpCode.value
    };

    setLoading(true);
    ResetUserPassword(ResetPasswordData)
      .then((result: any) => {
        setLoading(false);
        navigate("/login", { state: { verifyMessage: "Password updated successfully" }});
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <AuthenticationForms>
      <h1 className="h1">{t("ResetPassword")}</h1>
      <div className="inputs-container">
        <FieldInput label="Otp-code" isRequired {...register("otpCode")} defaultValue={default_cred?.otpCode} />
        <FieldInput label="password" isRequired {...register("password")} defaultValue={default_cred?.password} />
      </div>

      <SubmitBtn onSubmit={handleSubmit(resetPassword)} loading={loading} label="confirm" />

      <div className="clearfix"></div>

      <div className="separator"></div>

      <div className="loginRegisterQuestion">
        {t("backTo")}{" "}
        <Link to="/login" className="highlight">
          {t("login")}
        </Link>
      </div>
    </AuthenticationForms>
  );
};

export default memo(ResetPasswordC);
